import {
    faFlask,
    faCaretUp,
    faArrowUp,
    faPenFancy,
    faCodeBranch,
    faMoneyBill,
    faArrowCircleDown,
    faDolly,
    faArrowDown,
    faCloudUploadAlt,
    faClone,
    faExternalLinkAlt,
    faBook,
    faArrowLeft,
    faArrowRight,
    faLayerGroup,
    faCode,
    faArrowsAltV,
    faDesktop,
    faMobileAlt,
    faEllipsisH,
    faEllipsisV,
    faTags,
    faTimes,
    faBoxes,
    faPallet,
    faSignature,
    faCalendarAlt,
    faUniversity,
    faChartLine,
    faShoppingCart,
    faShoppingBasket,
    faSignOutAlt,
    faUserCircle,
    faClipboard,
    faUsers,
    faWrench,
    faFileInvoiceDollar,
    faInfo,
    faPlusCircle,
    faHome,
    faFolder,
    faClipboardList,
    faCheckCircle,
    faTimesCircle,
    faUndo,
    faSave,
    faFilePdf,
    faPlus,
    faDoorClosed,
    faDownload,
    faUser,
    faBuilding,
    faDoorOpen,
    faChevronRight,
    faUserPlus,
    faCircle,
    faFolderPlus,
    faCaretRight,
    faSync,
    faEdit,
    faFolderOpen,
    faEnvelope,
    faEye,
    faEyeSlash,
    faChevronLeft,
    faPencilRuler,
    faHeading,
    faAlignLeft,
    faAddressCard,
    faColumns,
    faImage,
    faImages,
    faMinus,
    faExpand,
    faCheck,
    faDollarSign,
    faBars,
    faTrash,
    faLock,
    faFileWord,
    faCog,
    faCalculator,
    faExclamation,
    faExclamationCircle,
    faFileExcel,
    faFilePowerpoint,
    faToolbox,
    faCouch,
    faPenAlt,
    faHashtag,
    faMoneyCheckAlt,
    faPenSquare,
    faMoneyCheck,
    faCreditCard,
    faMoneyBillWave,
    faMoneyBillAlt,
    faCalendarCheck,
    faGlobeAmericas,
    faRobot,
    faBan,
    faEuroSign,
    faVial,
    faEraser,
    faHandHoldingUsd,
    faPiggyBank,
    faFileInvoice,
    faFingerprint,
    faPrint,
    faToggleOff,
    faToggleOn,
    faInfoCircle,
    faTasks,
    faSortUp,
    faSortDown,
    faMapMarkerAlt,
    faSearchPlus,
    faSearchMinus,
    faBoxOpen,
    faRetweet,
    faCoins,
    faFileExport,
    faReceipt,
    faGift,
    faBullseye,
    faDotCircle,
    faCaretSquareRight,
    faAngleDown,
    faAngleUp,
    faAngleRight,
    faTable,
    faHandPointer,
    faPuzzlePiece,
    faHourglassHalf,
    faTruckMoving,
    faCommentDots,
    faPowerOff,
    faExpandArrowsAlt,
    faCompressArrowsAlt,
    faFilter,
    faChevronDown,
    faInbox,
} from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import {
    faCcAmex, faCcDinersClub, faCcDiscover, faCcJcb, faCcMastercard, faCcVisa,
    faYoutube,
} from '@fortawesome/free-brands-svg-icons'
import { faPoundSign } from "@fortawesome/free-solid-svg-icons/faPoundSign.js"

library.add(
    fab,
    faPenSquare,
    faMoneyCheckAlt,
    faHashtag,
    faCaretUp,
    faPenFancy,
    faPenAlt,
    faCodeBranch,
    faArrowUp,
    faMoneyBill,
    faArrowCircleDown,
    faDolly,
    faArrowDown,
    faCloudUploadAlt,
    faExternalLinkAlt,
    faClone,
    faBook,
    faArrowLeft,
    faArrowRight,
    faLayerGroup,
    faCode,
    faArrowsAltV,
    faMobileAlt,
    faDesktop,
    faEllipsisH,
    faEllipsisV,
    faTags,
    faTimes,
    faBoxes,
    faPallet,
    faSignature,
    faCalendarAlt,
    faUniversity,
    faCircle,
    faCog,
    faCalculator,
    faFolderPlus,
    faExclamationCircle,
    faExclamation,
    faHeading,
    faDollarSign,
    faBars,
    faFileWord,
    faFileExcel,
    faFilePowerpoint,
    faCheck,
    faExpand,
    faMinus,
    faAlignLeft,
    faColumns,
    faImage,
    faImages,
    faAddressCard,
    faPencilRuler,
    faFolderOpen,
    faLock,
    faChartLine,
    faChevronLeft,
    faEnvelope,
    faEye,
    faEyeSlash,
    faUserPlus,
    faShoppingCart,
    faClipboardList,
    faDownload,
    faCheckCircle,
    faTimesCircle,
    faUser,
    faEdit,
    faSync,
    faBuilding,
    faShoppingBasket,
    faClipboard,
    faPlusCircle,
    faSignOutAlt,
    faUserCircle,
    faCaretRight,
    faFolder,
    faUsers,
    faPlus,
    faFilePdf,
    faWrench,
    faInfo,
    faSave,
    faHome,
    faTrash,
    faUndo,
    faDoorClosed,
    faDoorOpen,
    faChevronRight,
    faFileInvoiceDollar,
    faToolbox,
    faCouch,
    faYoutube,
    faMoneyCheck,
    faMoneyBill,
    faMoneyBillWave,
    faMoneyBillAlt,
    faCreditCard,
    faCalendarCheck,
    faGlobeAmericas,
    faRobot,
    faBan,
    faEuroSign,
    faPoundSign,
    faVial,
    faEraser,
    faHandHoldingUsd,
    faPiggyBank,
    faFileInvoice,
    faFingerprint,
    faPrint,
    faToggleOff,
    faToggleOn,
    faInfoCircle,
    faCcAmex,
    faCcMastercard,
    faCcVisa,
    faCcDinersClub,
    faCcJcb,
    faCcDiscover,
    faTasks,
    faSortUp,
    faSortDown,
    faMapMarkerAlt,
    faSearchPlus,
    faSearchMinus,
    faBoxOpen,
    faRetweet,
    faCoins,
    faFileExport,
    faReceipt,
    faGift,
    faBullseye,
    faDotCircle,
    faCaretSquareRight,
    faCog,
    faAngleDown,
    faAngleUp,
    faAngleRight,
    faTable,
    faHandPointer,
    faPuzzlePiece,
    faHourglassHalf,
    faTruckMoving,
    faCommentDots,
    faPowerOff,
    faExpandArrowsAlt,
    faCompressArrowsAlt,
    faFilter,
    faChevronRight,
    faChevronDown,
    faInbox,
    faFlask,
)
export { default as GlobalHelper } from './common/GlobalHelper.jsx';
export { version } from '../server/version.js'

const imports = {
    polyfill: require('@babel/polyfill'),
    main_scss: require('./common/main.scss'),
    react_dates: require('react-dates/initialize'),
}

export default imports;


// WEBPACK FOOTER //
// ./src/indexImports.js